import styled from 'styled-components';

const ProductImg = styled.img`
  padding-top: ${props => (props.padTop ? props.padTop : '5%')};
  width: ${props => (props.width ? props.width : '100%')};
  height: auto;
  ${props => props.minWidth && `min-width: ${props.minWidth};`}
  ${props => props.minHeight && `min-height: ${props.minHeight};`}
`;

export default ProductImg;
